import {omit} from "lodash";
import ActiveController from '@/controller.active';

const illegalCharacters = [9, 16, 17, 18, 20, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 91, 112, 113, 114, 115, 116,
	117, 118, 119, 120, 121, 122, 123, 144, 225];

class companiesDetailController extends ActiveController{
  constructor(
    $auth,
    $companies,
    $stateParams,
    CONFIG,
    $timeout
  ){
    'ngInject';
    super();

    this.$auth = $auth;
    this.$companies = $companies;
    this.$timeout = $timeout;

    this.config = {
      id : $stateParams.id,
      target : $stateParams.target || 'Users',
      sub: [
        'users'
      ]
    };

    this.tableConfiguration = {
			archived: 0,
      search: "",
		};

    this.userList = [];
    this.operators = [];
    this.users = [];
    this.accountManager = null;

    this.$companies.setUri( CONFIG.API.companies );
    this.activityHoursStartLabel = null;
    this.activityHoursEndLabel = null;

    this.companyUri = this.$auth.getUser().company;

    this._retrieveCompany();
    this.setType('data');
  }

  $onInit() {
    this.search();
  }


  $onCompanyLoaded(){
    if (this.data && this.data.account_manager) {
      setTimeout(() => this.getAccountManager(this.data.account_manager));
    }
    //this.search();
  }

  search() {
    if (this.tableConfiguration.search) {
      this.userList = this.data.sub['Users']
        .filter(user => user.text.toLowerCase().indexOf(this.tableConfiguration.search.toLowerCase()) !== -1)
        .filter(user => this.tableConfiguration.archived ? user.suspended === true : user.suspended === false);
    } else {
      this.userList = this.data.sub['Users']
        .filter(user => this.tableConfiguration.archived ? user.suspended === true : user.suspended === false);
    }
  }

  get invoiceAccounts() {
    return this.$companies.collections.invoiceAccounts;
  }

  setType( type ){
    this.type = type;
  }

  getType(){
    return this.type;
  }

  getAccountManager(accountManagerUri) {
    this.$companies
      .activeGet(accountManagerUri)
      .then(user => {
          if (user) {
            this.accountManager = user;
          }
        });
  }

  $getUsers($event, $select, defaultSearch = null) {

    const companyUri = this.$auth.getUser().company;

		let search = defaultSearch;

		const $query = () => this.$companies
				.$search(companyUri + '/users', {search: search ? search : null})
				.then(users => this.users = users);

		if(!$event && !$select){
			return $query();
		}


		if (illegalCharacters.indexOf($event.which) !== -1) {
			return false;
		}

		if (this._timeout) {
			this.$timeout.cancel(this._timeout);
		}

		this._timeout = this.$timeout(() => {
			search = $select.searchInput.val();
			$query();
			this._timeout = null;
		}, 300);

	}

  _retrieveCompany(){
    this.$companies
      .getCompany( this.config.id )
      .then( company => {
        this.data = company;
        this.data.sub = {};
        this.activityHoursStartLabel = this.millisecondsToDate(this.data.activity_hours_start || 0);
        this.activityHoursEndLabel = this.millisecondsToDate(this.data.activity_hours_end || 0);
        this.$companies.currentCompany = this.data;
        this.uris = this.getTabsByUris( this.data.uris );
        if( this.config.target ){
          this._prepareSub();
        }
        this.$onCompanyLoaded();
      });
  }

  _prepareSub(){
    this.$companies
      .sub( this.config.id, this.config.target )
      .then(data => {
        this.data.sub[ this.config.target ] = data;
        this.search();
      });
  }

  $onChange() {
    this.data.account_manager = this.accountManager ? this.accountManager.uri : null;
  }

  get selectedCompany() {
    console.log(this.data);
    return this.data;
  }

  millisecondsToDate(millisecondsFromMidnight) {
    const date = new Date();
    const midnight = new Date(date);
    midnight.setHours(0, 0, 0, 0); // Set to midnight
    const result = new Date(midnight.getTime() + millisecondsFromMidnight);
    return result;
  }

  dateToMilliseconds(date) {
    const midnight = new Date(date);
    midnight.setHours(0, 0, 0, 0); // Set to midnight
    const result = date.getTime() - midnight.getTime();
    return result;
  }

  $onSetStartTime(newDate, oldDate){
    $('#d-time-start').parent().removeClass('open');
    this.data.activity_hours_start = this.dateToMilliseconds(newDate);
    console.log(this.data);
    this.activityHoursStartLabel = this.millisecondsToDate(this.data.activity_hours_start || 0);
  }

  $onSetEndTime(newDate, oldDate){
    $('#d-time-end').parent().removeClass('open');
    this.data.activity_hours_end = this.dateToMilliseconds(newDate);
    console.log(this.data);
    this.activityHoursEndLabel = this.millisecondsToDate(this.data.activity_hours_end || 0);
  }
  
  $save(){
  	const data = angular.copy(omit(this.data, ['sub']));
    this.$companies.activePut(data.uri, data)
      .then(() => this.$companies.notify.set(this.$companies.$translates.get('COMPANIES_UPDATE_SUCCESS'), 'success'))
      .catch( (err) => this.notify.set(err.data.reason, 'error'));
  }

}

export default companiesDetailController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-detail/companies-detail.controller.js
 **/